import {InjectionToken} from "@angular/core";

import {OverlayComponent, OverlayConfig} from "framework/ui/overlays/overlay.component";
import {Observable, Subject, Subscription} from "rxjs";

export const OVERLAY_DATA = new InjectionToken<any>("OVERLAY_DATA");

export interface OverlayDialogConfig<T>
{
    config?: OverlayConfig;
    data: T;
}

export class OverlayDialogRef<R>
{
    private m_afterClose = new Subject<R>();
    private closeSub: Subscription;

    public readonly id: string;

    get hasCloseButton(): boolean
    {
        return this.m_component?.config.showCloseButton;
    }

    constructor(private m_component: OverlayComponent)
    {
        this.id       = this.m_component.config.id;
        this.closeSub = this.m_component.closed.subscribe(undefined, undefined, () => this.closed());
    }

    afterClose(): Observable<R>
    {
        return this.m_afterClose.asObservable();
    }

    close(result?: R)
    {
        if (this.m_component)
        {
            this.m_component.closeOverlay();
            this.closed(result);
            this.m_component = null;
        }
    }

    private closed(result?: R)
    {
        this.closeSub.unsubscribe();
        this.m_afterClose.next(result);
        this.m_afterClose.complete();
    }
}

export class OverlayDialogUpdate<T>
{
    constructor(public readonly result: T) {}
}
